// Hook pour récupérer les données utilisateur connecté
import { useState, useEffect, useMemo } from 'react';

export function useCurrentUser() {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  useEffect(() => {
    // Essayer plusieurs sources de données utilisateur
    const ecosystemUser = localStorage.getItem('ecosystem_user');
    const ecosystemProfile = localStorage.getItem('ecosystem_profile');
    const ecosystemToken = localStorage.getItem('ecosystem_token');
    const buyerUser = localStorage.getItem('buyer_user');
    const buyerToken = localStorage.getItem('buyer_token');
    
    let userData = null;
    
    // Si on a un token, on a un vrai utilisateur connecté
    const hasRealToken = ecosystemToken || buyerToken;
    
    if (ecosystemUser) {
      try {
        const parsed = JSON.parse(ecosystemUser);
        userData = {
          id: parsed.id || parsed._id || parsed.user_id,
          name: parsed.name || parsed.display_name || `${parsed.first_name || ''} ${parsed.last_name || ''}`.trim() || 'Utilisateur',
          firstName: parsed.first_name || parsed.name?.split(' ')[0] || 'Utilisateur',
          lastName: parsed.last_name || parsed.name?.split(' ')[1] || '',
          email: parsed.email || '',
          trust_level: parsed.trust_level || null,
          isDemo: false,
        };
      } catch(e) {}
    }
    
    // Enrichir avec les données du profil (trust_level peut être là)
    if (ecosystemProfile) {
      try {
        const parsed = JSON.parse(ecosystemProfile);
        if (!userData) {
          userData = {
            name: parsed.real_name || parsed.display_name || 'Utilisateur',
            firstName: parsed.real_name?.split(' ')[0] || parsed.display_name?.split(' ')[0] || 'Utilisateur',
            lastName: parsed.real_name?.split(' ')[1] || '',
            email: parsed.email || '',
            trust_level: parsed.trust_level || null,
            isDemo: false,
          };
        } else {
          // Ajouter trust_level du profil si pas dans user
          userData.trust_level = userData.trust_level || parsed.trust_level || null;
        }
      } catch(e) {}
    }
    
    if (!userData && buyerUser) {
      try {
        const parsed = JSON.parse(buyerUser);
        userData = {
          id: parsed.id || parsed._id || parsed.user_id,
          name: parsed.name || 'Utilisateur',
          firstName: parsed.name?.split(' ')[0] || 'Utilisateur',
          lastName: parsed.name?.split(' ')[1] || '',
          email: parsed.email || '',
          trust_level: parsed.trust_level || null,
          isDemo: false,
        };
      } catch(e) {}
    }
    
    // Si on a un token mais pas de données user, c'est un vrai utilisateur (données pas encore chargées)
    if (!userData && hasRealToken) {
      userData = {
        name: 'Utilisateur',
        firstName: 'Utilisateur',
        lastName: '',
        email: '',
        trust_level: null,
        isDemo: false,
      };
    }
    
    // PLUS DE MODE DÉMO - Si pas connecté, user est null
    setIsLoggedIn(!!hasRealToken);
    setUser(userData);
  }, []);
  
  const initials = useMemo(() => {
    if (!user) return '?';
    const f = user.firstName?.[0]?.toUpperCase() || '';
    const l = user.lastName?.[0]?.toUpperCase() || '';
    return f + l || 'U';
  }, [user]);
  
  // Helper pour vérifier si l'utilisateur est Super Confiance
  const isSuperConfiance = user?.trust_level === 'super_confiance';
  
  return { user, initials, isLoggedIn, isSuperConfiance };
}

export default useCurrentUser;
